import { AccCoaApiPath, MenuIds } from "../../../constants";
import { getWithMenu } from "../../../core/helpers";
export const getSearchAccCoa = async (searchParams) => {
    return await getWithMenu(AccCoaApiPath, MenuIds.AKUNTANSI.PEMBUKUAN.SETTING.PERKIRAAN.id, { page: 0, size: 500, ...searchParams });
};
export const getAccCoaById = async (idCoa) => {
    return await getWithMenu(`${AccCoaApiPath}/${idCoa}`, MenuIds.AKUNTANSI.PEMBUKUAN.SETTING.PERKIRAAN.id);
};
